import React from 'react'
import { Link, useParams, Route } from 'react-router-dom'
import { Breadcrumb, Row, Col, Result } from 'antd'
import { useQuery } from '@apollo/client'
import {
  QUERY_PRODUCT,
  QUERY_MERCHANT_PRODUCT_CATEGORIES,
  QUERY_MERCHANT_SETTING,
  QUERY_MERCHANT_MODIFIER_GROUPS,
  QUERY_STORE_IDS
} from '../ProductQueries'
import { useSession } from '@slerp/accounts'
import Loading from '../../Utils/Loading'
import Product from './Product'
import ModifiersForm from './ModifiersForm'
import VariantsForm from './VariantsForm'
import Sidebar from './Sidebar'

const ProductAdvanceFeature = () => {
  const { slug, id } = useParams()
  const { merchant } = useSession()

  const { data: product, refetch: refetchProducts } = useQuery(QUERY_PRODUCT, {
    variables: { id: id }
  })

  const {
    data: categories,
    refetch: categoriesRefetch,
    error: categoriesError
  } = useQuery(QUERY_MERCHANT_PRODUCT_CATEGORIES, {
    variables: { merchant: merchant.slug }
  })

  const {
    data: settings,
    refetch: settingsRefetch,
    error: settingsError
  } = useQuery(QUERY_MERCHANT_SETTING, {
    variables: { merchant: merchant.slug }
  })

  const { data: modifierGroups, error: modifierGroupsError } = useQuery(
    QUERY_MERCHANT_MODIFIER_GROUPS,
    {
      variables: {
        merchant: merchant.slug
      }
    }
  )

  const { data: storeId, error: storeIdError } = useQuery(QUERY_STORE_IDS, {
    variables: { merchant: merchant.slug }
  })

  if (categoriesError || settingsError || modifierGroupsError || storeIdError) {
    return <Result status='404' title='Please reload page.' />
  }

  const ProductRoutes = () => {
    return (
      <>
        <Route
          path={`/product/${slug}/${id}/edit/general`}
          component={() => (
            <Product
              categories={categories.categories}
              refetchCategories={categoriesRefetch}
              product={product.products[0]}
              settings={settings.merchants[0].setting}
              refetchSettings={settingsRefetch}
              refetchProducts={refetchProducts}
            />
          )}
        />
        <Route
          path={`/product/${slug}/${id}/edit/modifiers`}
          component={() => (
            <ModifiersForm
              modifierGroups={modifierGroups.modifier_groups}
              product={product.products[0]}
            />
          )}
        />
        <Route
          path={`/product/${slug}/${id}/edit/variants`}
          component={() => (
            <VariantsForm
              product={product.products[0]}
              storeId={storeId.stores}
              refetchProducts={refetchProducts}
            />
          )}
        />
      </>
    )
  }

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to='/products'>Products</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Advanced Features</Breadcrumb.Item>
        {product && product.products[0] && (
          <Breadcrumb.Item>{product.products[0].name}</Breadcrumb.Item>
        )}
      </Breadcrumb>
      <Row data-testid='advance-feature-tabs'>
        <Col span={4}>
          <Sidebar />
        </Col>
        <Col span={19} offset={1}>
          {(product && categories && settings && storeId && modifierGroups && (
            <ProductRoutes />
          )) || <Loading />}
        </Col>
      </Row>
    </>
  )
}

export default ProductAdvanceFeature
